// Main Lithuanian cities
export const LITHUANIAN_CITIES = [
  'Vilnius',
  'Kaunas',
  'Klaipėda',
  'Šiauliai',
  'Panevėžys',
  'Alytus',
  'Marijampolė',
  'Mažeikiai',
  'Jonava',
  'Utena',
  'Kėdainiai',
  'Telšiai',
  'Tauragė',
  'Ukmergė',
  'Visaginas',
  'Plungė',
  'Kretinga',
  'Palanga',
  'Radviliškis',
  'Druskininkai',
  'Rokiškis',
  'Biržai',
  'Jurbarkas',
  'Garliava',
  'Elektrėnai',
  'Kuršėnai',
  'Gargždai',
  'Skuodas',
  'Varėna',
  'Zarasai',
  'Šilutė',
  'Šilalė',
  'Raseiniai',
  'Prienai',
  'Lazdijai',
  'Kazlų Rūda',
  'Anykščiai',
  'Ignalina',
  'Molėtai',
  'Trakai',
  'Širvintos',
  'Švenčionys',
  'Švenčionėliai',
  'Lentvaris',
  'Nemenčinė',
  'Grigiškės',
  'Kaišiadorys',
  'Šakiai',
  'Vilkaviškis',
];

// Municipalities grouped by county (apskritis)
export const LITHUANIAN_MUNICIPALITIES: { county: string; municipalities: string[] }[] = [
  {
    county: 'Vilniaus apskritis',
    municipalities: [
      'Vilniaus miesto savivaldybė',
      'Vilniaus rajono savivaldybė',
      'Šalčininkų rajono savivaldybė',
      'Švenčionių rajono savivaldybė',
      'Širvintų rajono savivaldybė',
      'Molėtų rajono savivaldybė',
      'Ukmergės rajono savivaldybė',
      'Elektrėnų savivaldybė',
      'Trakų rajono savivaldybė',
    ],
  },
  {
    county: 'Kauno apskritis',
    municipalities: [
      'Kauno miesto savivaldybė',
      'Kauno rajono savivaldybė',
      'Jonavos rajono savivaldybė',
      'Kėdainių rajono savivaldybė',
      'Prienų rajono savivaldybė',
      'Kaišiadorių rajono savivaldybė',
      'Raseinių rajono savivaldybė',
      'Birštono savivaldybė',
    ],
  },
  {
    county: 'Klaipėdos apskritis',
    municipalities: [
      'Klaipėdos miesto savivaldybė',
      'Klaipėdos rajono savivaldybė',
      'Neringos savivaldybė',
      'Palangos miesto savivaldybė',
      'Skuodo rajono savivaldybė',
      'Kretingos rajono savivaldybė',
      'Šilutės rajono savivaldybė',
    ],
  },
  {
    county: 'Šiaulių apskritis',
    municipalities: [
      'Šiaulių miesto savivaldybė',
      'Šiaulių rajono savivaldybė',
      'Radviliškio rajono savivaldybė',
      'Pakruojo rajono savivaldybė',
      'Joniškio rajono savivaldybė',
      'Kelmės rajono savivaldybė',
      'Akmenės rajono savivaldybė',
    ],
  },
  {
    county: 'Panevėžio apskritis',
    municipalities: [
      'Panevėžio miesto savivaldybė',
      'Panevėžio rajono savivaldybė',
      'Rokiškio rajono savivaldybė',
      'Biržų rajono savivaldybė',
      'Pasvalio rajono savivaldybė',
      'Kupiškio rajono savivaldybė',
    ],
  },
  {
    county: 'Alytaus apskritis',
    municipalities: [
      'Alytaus miesto savivaldybė',
      'Alytaus rajono savivaldybė',
      'Druskininkų savivaldybė',
      'Lazdijų rajono savivaldybė',
      'Varėnos rajono savivaldybė',
    ],
  },
  {
    county: 'Marijampolės apskritis',
    municipalities: [
      'Marijampolės savivaldybė',
      'Kazlų Rūdos savivaldybė',
      'Kalvarijos savivaldybė',
      'Šakių rajono savivaldybė',
      'Vilkaviškio rajono savivaldybė',
    ],
  },
  {
    county: 'Tauragės apskritis',
    municipalities: [
      'Tauragės rajono savivaldybė',
      'Jurbarko rajono savivaldybė',
      'Pagėgių savivaldybė',
      'Šilalės rajono savivaldybė',
    ],
  },
  {
    county: 'Telšių apskritis',
    municipalities: [
      'Telšių rajono savivaldybė',
      'Mažeikių rajono savivaldybė',
      'Plungės rajono savivaldybė',
      'Rietavo savivaldybė',
    ],
  },
  {
    county: 'Utenos apskritis',
    municipalities: [
      'Utenos rajono savivaldybė',
      'Zarasų rajono savivaldybė',
      'Anykščių rajono savivaldybė',
      'Ignalinos rajono savivaldybė',
      'Visagino savivaldybė',
    ],
  },
];

// Flat list of all location options (cities + municipalities) for search/filter use
export const ALL_LITHUANIAN_LOCATIONS = [
  ...LITHUANIAN_CITIES,
  ...LITHUANIAN_MUNICIPALITIES.flatMap(g => g.municipalities),
];
